var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "video-player" }, [
    _vm.flashFlag
      ? _c("span", [
          _c("embed", {
            attrs: {
              src: _vm.url,
              allowFullScreen: _vm.allowFullScreen,
              quality: _vm.quality,
              width: _vm.width,
              height: _vm.height,
              align: "middle",
              allowScriptAccess: "always",
              type: "application/x-shockwave-flash"
            }
          })
        ])
      : _c("span", [
          _c(
            "video",
            {
              staticClass: "video-js vjs-default-skin vjs-big-play-centered",
              attrs: {
                controls: "",
                preload: "auto",
                width: _vm.width,
                height: _vm.height,
                poster: _vm.poster
              }
            },
            [_c("source", { attrs: { src: _vm.url } }), _vm._v(" "), _vm._m(0)]
          )
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "vjs-no-js" }, [
      _vm._v(
        "\n                要观看此视频，请启用浏览器的Javascript脚本功能，并升级到"
      ),
      _c(
        "a",
        {
          attrs: {
            href: "http://videojs.com/html5-video-support/",
            target: "_blank"
          }
        },
        [_vm._v("支持Html5视频")]
      ),
      _vm._v("的浏览器 ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-56ca6c66", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56ca6c66","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/ctrl/VideoPlayer.vue
// module id = 1623
// module chunks = 1